import AuroraApplicationSelector from './AuroraApplicationSelector';
import { services } from '@broadleaf/admin-components';

const { ComponentRegistrar } = services;

ComponentRegistrar.registerComponent(
  'blApplicationSelector',
  AuroraApplicationSelector
);
